import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutAvailableRatewareTariffs extends Layout {
    sourceRatewareTariffCode: DataSource;
    tableAvailableTariffs: Table;
}
